import { render, staticRenderFns } from "./sosForm.vue?vue&type=template&id=2bbf61c9"
import script from "./sosForm.vue?vue&type=script&lang=js"
export * from "./sosForm.vue?vue&type=script&lang=js"
import style0 from "./sosForm.vue?vue&type=style&index=0&id=2bbf61c9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports